import { Box } from "@chakra-ui/react";
import { useGetTransferHistoryByIdQuery } from "apis";
import { ActionBar, PageMotion, PoweredBy, TransferData } from "components";
import { PageProps } from "interfaces";
import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";

export interface TransactionProps extends PageProps {}

export function Transaction(props: TransactionProps) {
  const { id } = useParams();

  const [pollingInterval, setPollingInterval] = useState(5000);
  const { data, isSuccess } = useGetTransferHistoryByIdQuery(id!, {
    skip: id ? false : true,
    pollingInterval,
  });

  useEffect(() => {
    (data?.status === "TransferComplete" || data?.status === "TransferCancelled" || data?.status === "TransferFailed") &&
      setPollingInterval(0);
  }, [data?.status]);

  const navigate = useNavigate();

  return (
    <PageMotion key="Transaction Details" px={{ base: "16px", "1sm": "4px" }} minH={{ base: "98vh" }}>
      <Box maxW="435px" m="0 auto" pos="relative">
        <ActionBar onBackClick={() => navigate("/transfer-history")} title="Transfer Details" />

        <TransferData data={data!} isSuccess={isSuccess} />
      </Box>

      <PoweredBy />
    </PageMotion>
  );
}
